import React, { useState, useEffect } from "react";

const AiEdit = ({
isOpen,
onClose,
onSave,
rect,
}) => {

const [formData, setFormData] = useState({
rect: JSON.parse(JSON.stringify(rect))
});

const [isApplying, setIsApplying] = useState(false);

useEffect(() => {


if (isOpen) {

  const tempRect = JSON.parse(JSON.stringify(rect));

  setFormData({
    rect: tempRect
  });

}


}, [isOpen, rect]);

function handleInputChange(e) {


const value = e.target.value;

setFormData(prev => ({
  ...prev,
  rect: {
    ...prev.rect,
    aiCode: value
  }
}));


}

const handleSave = async () => {


setIsApplying(true);

try {

  if (onSave) {
    await onSave(formData);
  }

  onClose();

}
catch (e) {

  console.error("Error saving AI edit:", e);

  setIsApplying(false);

}


};

if (!isOpen) {
return null;
}

const styles = {


backdrop: {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.4)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 50,
},


modal: {
  backgroundColor: "#fff",
  borderRadius: "8px",
  padding: "20px",
  width: "90%",
  maxWidth: "700px",
  height: "80vh",
  maxHeight: "850px",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
  boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
  overscrollBehaviorY: "contain",
},


label: {
  display: "block",
  marginBottom: "8px",
  fontSize: "14px",
  fontWeight: "500"
},


textarea: {
  display: "block",
  width: "100%",
  flex: 1,
  minHeight: "400px",
  padding: "10px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  fontSize: "13px",
  lineHeight: "1.45",
  fontFamily: "monospace",
  boxSizing: "border-box",
  resize: "none",
  overflowY: "auto",  
  overscrollBehaviorY: "contain",
  outline: "none"
},


modalButtons: {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  marginTop: "15px",
},


button: {
  padding: "6px 12px",
  fontSize: "14px",
  borderRadius: "4px",
  border: "none",
  cursor: "pointer",
},


cancel: {
  backgroundColor: "#e0e0e0"
},


save: {
  backgroundColor: "#007bff",
  color: "#fff",
  minWidth: "65px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
},


};

return (


<div style={styles.backdrop}>

  <div  style={styles.modal}>

    {/* AI Code */}

    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0
      }}
    >

      <label style={styles.label}>
        Edit AI Code:
      </label>

      <textarea
        id="scroll-list"
        name="AI Code"
        value={formData.rect?.aiCode || ""}
        onChange={handleInputChange}
        style={styles.textarea}
        disabled={isApplying}
        spellCheck={false}
      />

    </div>


    {/* Buttons */}

    <div style={styles.modalButtons}>

      <button
        style={{
          ...styles.button,
          ...styles.cancel,
          opacity: isApplying ? 0.5 : 1,
          cursor: isApplying
            ? "not-allowed"
            : "pointer"
        }}
        onClick={onClose}
        disabled={isApplying}
      >
        Cancel
      </button>


      <button
        style={{
          ...styles.button,
          ...styles.save,
          cursor: isApplying
            ? "wait"
            : "pointer",
        }}
        onClick={handleSave}
        disabled={isApplying}
      >

        {isApplying ? (

          <span
            style={{
              width: "14px",
              height: "14px",
              border: "2px solid rgba(255,255,255,0.4)",
              borderTop: "2px solid white",
              borderRadius: "50%",
              display: "inline-block",
              animation:
                "aiEditSpin 0.7s linear infinite",
            }}
          />

        ) : (

          "Save"

        )}

      </button>

    </div>

  </div>


  <style>
    {`
      @keyframes aiEditSpin {
        from {
          transform: rotate(0deg);
        }

        to {
          transform: rotate(360deg);
        }
      }
    `}
  </style>

</div>

);
};

export default AiEdit;



